import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const ZoneIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M20,3.33c0-.87-.35-1.71-.96-2.33h0c-.63-.64-1.48-1-2.37-1H3.33C1.49,0,0,1.49,0,3.33v13.33c0,.87.35,1.71.96,2.33h0c.63.64,1.48,1,2.37,1h13.33c.87,0,1.71-.35,2.33-.96h0c.64-.63,1-1.48,1-2.37V3.33ZM10.94,10l7.53-7.53c.13.27.2.56.2.86v13.33c0,.3-.07.59-.2.86l-7.53-7.53ZM1.33,3.33c0-1.1.9-2,2-2h13.33c.3,0,.59.07.86.2L1.53,17.53c-.13-.27-.19-.57-.19-.87V3.33ZM3.33,18.67c-.3,0-.59-.07-.86-.2l7.53-7.53,7.53,7.53c-.27.13-.56.2-.86.2H3.33Z" />
  <path d="M5.54,10.49c.26.25.66.25.92,0,.48-.49,2.87-2.81,2.87-4.49,0-1.84-1.49-3.33-3.33-3.33s-3.33,1.49-3.33,3.33c0,1.67,2.39,4,2.87,4.49h0ZM6,4c1.1,0,2,.9,2,2,0,.7-1.05,2.07-2,3.06-.95-.99-2-2.36-2-3.06,0-1.1.9-2,2-2Z" />
 </svg>,
 "Zone"
);
